module.exports = "<div data-bounce1></div><div data-bounce2></div><div data-bounce3></div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/spinner_three_bounce/public/spinner.html
 ** module id = 143
 ** module chunks = 0
 **/